import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'


const _hoisted_1 = {
  key: 1,
  class: "h-full"
}
const _hoisted_2 = { class: "py-4 flex flex-row justify-start items-center border-b border-gray-lp-400" }
const _hoisted_3 = { class: "font-semibold text-20px mr-4 text-black-lp-200" }
const _hoisted_4 = {
  key: 1,
  class: "flex flex-row py-6 h-full"
}
const _hoisted_5 = { class: "w-2/3 px-4 text-12px xxl:text-14px overflow-y-auto pb-20" }
const _hoisted_6 = { class: "py-3" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " ID Embargo ", -1)
const _hoisted_8 = { class: "my-1 text-black-lp-300 text-12px xxl:text-14px font-normal" }
const _hoisted_9 = { class: "py-3" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " Nama Embargo ", -1)
const _hoisted_11 = { class: "my-1 text-black-lp-300 text-12px xxl:text-14px font-normal capitalize" }
const _hoisted_12 = { class: "py-3" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " Kota Asal ", -1)
const _hoisted_14 = { class: "my-1 text-black-lp-300 text-12px xxl:text-14px font-normal flex flex-row" }
const _hoisted_15 = { class: "rounded px-2 py-0 bg-gray-lp-200 mr-2" }
const _hoisted_16 = { class: "py-3" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " Destinasi ", -1)
const _hoisted_18 = { class: "my-1 text-black-lp-300 text-12px xxl:text-14px font-normal flex flex-row" }
const _hoisted_19 = { class: "rounded px-2 py-0 bg-gray-lp-200 mr-2" }
const _hoisted_20 = { class: "py-3" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " Tipe Pengiriman ", -1)
const _hoisted_22 = {
  key: 0,
  class: "my-1 text-black-lp-300 text-12px xxl:text-14px font-normal flex flex-row"
}
const _hoisted_23 = { class: "rounded px-2 py-0 bg-gray-lp-200 mr-2 uppercase" }
const _hoisted_24 = { class: "py-3" }
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " Produk Pengiriman ", -1)
const _hoisted_26 = { class: "my-1 text-black-lp-300 text-12px xxl:text-14px font-normal flex flex-row" }
const _hoisted_27 = { class: "rounded px-2 py-0 bg-gray-lp-200 mr-2" }
const _hoisted_28 = { class: "py-3" }
const _hoisted_29 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " Komoditas Pengiriman ", -1)
const _hoisted_30 = { class: "my-1 text-black-lp-300 text-12px xxl:text-14px font-normal flex flex-row" }
const _hoisted_31 = { class: "rounded px-2 py-0 bg-gray-lp-200 mr-2" }
const _hoisted_32 = { class: "py-3" }
const _hoisted_33 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " Berat Maksimal ", -1)
const _hoisted_34 = { class: "my-1 text-black-lp-300 text-12px xxl:text-14px font-normal capitalize" }
const _hoisted_35 = { class: "py-3" }
const _hoisted_36 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " Dimulai Dari ", -1)
const _hoisted_37 = { class: "my-1 text-black-lp-300 text-12px xxl:text-14px font-normal capitalize" }
const _hoisted_38 = { class: "py-3" }
const _hoisted_39 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " Sampai ", -1)
const _hoisted_40 = { class: "my-1 text-black-lp-300 text-12px xxl:text-14px font-normal capitalize" }
const _hoisted_41 = { class: "w-1/3 px-8 text-12px xxl:text-14px border-l border-gray-lp-400" }
const _hoisted_42 = { class: "py-3" }
const _hoisted_43 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " Status Embargo ", -1)
const _hoisted_44 = { class: "my-1 text-black-lp-300 text-12px xxl:text-14px font-normal" }
const _hoisted_45 = { class: "flex" }
const _hoisted_46 = { class: "capitalize" }
const _hoisted_47 = { class: "py-3" }
const _hoisted_48 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " Tanggal Dibuat ", -1)
const _hoisted_49 = { class: "my-1 text-black-lp-300 text-12px xxl:text-14px font-normal" }
const _hoisted_50 = { class: "text-gray-lp-500" }
const _hoisted_51 = { class: "py-3" }
const _hoisted_52 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " Terakhir Diubah ", -1)
const _hoisted_53 = { class: "my-1 text-black-lp-300 text-12px xxl:text-14px font-normal" }
const _hoisted_54 = { class: "text-gray-lp-500" }
const _hoisted_55 = {
  key: 0,
  class: "py-3 inline-flex"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageDetailLazyLoad = _resolveComponent("PageDetailLazyLoad")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_button_fill = _resolveComponent("button-fill")!

  return (_ctx.isLoading)
    ? (_openBlock(), _createBlock(_component_PageDetailLazyLoad, {
        key: 0,
        onBack: _ctx.goBack
      }, null, 8, ["onBack"]))
    : (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("img", {
            src: _imports_0,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
            class: "w-5 mr-3 cursor-pointer",
            alt: "back"
          }),
          _createVNode("div", _hoisted_3, _toDisplayString(_ctx.detailData.embargo_name), 1)
        ]),
        (_ctx.isError)
          ? (_openBlock(), _createBlock(_component_ErrorMessage, {
              key: 0,
              errorType: _ctx.errorCause,
              onTryAgain: _ctx.getDetail
            }, null, 8, ["errorType", "onTryAgain"]))
          : (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode("div", _hoisted_8, _toDisplayString(_ctx.detailData.embargo_id), 1)
                ]),
                _createVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode("div", _hoisted_11, _toDisplayString(_ctx.detailData.embargo_name), 1)
                ]),
                _createVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode("div", _hoisted_14, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.detailData.origin_detail, (item, index) => {
                      return (_openBlock(), _createBlock("div", { key: index }, [
                        _createVNode("div", _hoisted_15, _toDisplayString(item.code), 1)
                      ]))
                    }), 128))
                  ])
                ]),
                _createVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createVNode("div", _hoisted_18, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.detailData.destination_detail, (item, index) => {
                      return (_openBlock(), _createBlock("div", { key: index }, [
                        _createVNode("div", _hoisted_19, _toDisplayString(item.code), 1)
                      ]))
                    }), 128))
                  ])
                ]),
                _createVNode("div", _hoisted_20, [
                  _hoisted_21,
                  (_ctx.detailData.service_type)
                    ? (_openBlock(), _createBlock("div", _hoisted_22, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.detailData.service_type.split(','), (item, index) => {
                          return (_openBlock(), _createBlock("div", { key: index }, [
                            _createVNode("div", _hoisted_23, _toDisplayString(item), 1)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createVNode("div", _hoisted_26, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.detailData.product_type.split(','), (item, index) => {
                      return (_openBlock(), _createBlock("div", { key: index }, [
                        _createVNode("div", _hoisted_27, _toDisplayString(item), 1)
                      ]))
                    }), 128))
                  ])
                ]),
                _createVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _createVNode("div", _hoisted_30, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.detailData.commodity_type_detail, (item, index) => {
                      return (_openBlock(), _createBlock("div", { key: index }, [
                        _createVNode("div", _hoisted_31, _toDisplayString(item.commodity_code), 1)
                      ]))
                    }), 128))
                  ])
                ]),
                _createVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _createVNode("div", _hoisted_34, _toDisplayString(_ctx.detailData.max_weight) + " Kg ", 1)
                ]),
                _createVNode("div", _hoisted_35, [
                  _hoisted_36,
                  _createVNode("div", _hoisted_37, _toDisplayString(_ctx.formatDate(_ctx.detailData.start_date_time)), 1)
                ]),
                _createVNode("div", _hoisted_38, [
                  _hoisted_39,
                  _createVNode("div", _hoisted_40, _toDisplayString(_ctx.formatDate(_ctx.detailData.end_date_time)), 1)
                ])
              ]),
              _createVNode("div", _hoisted_41, [
                _createVNode("div", _hoisted_42, [
                  _hoisted_43,
                  _createVNode("div", _hoisted_44, [
                    _createVNode("div", _hoisted_45, [
                      _createVNode("div", {
                        class: 
                  `rounded-full px-2 py-0 font-medium ${
                    _ctx.detailData.status.toLowerCase() === 'active'
                      ? 'bg-green-lp-300'
                      : _ctx.detailData.status.toLowerCase() === 'expired'
                      ? 'bg-red-lp-600'
                      : 'bg-yellow-lp-200'
                  } ${
                    _ctx.detailData.status.toLowerCase() === 'active'
                      ? 'text-green-lp-200'
                      : _ctx.detailData.status.toLowerCase() === 'expired'
                      ? 'text-red-lp-500'
                      : 'text-yellow-lp-100'
                  }`
                
                      }, [
                        _createVNode("span", _hoisted_46, _toDisplayString(_ctx.detailData.status.toLowerCase() === "pending"
                      ? "Upcoming"
                      : _ctx.detailData.status.toLowerCase() === "expired"
                      ? "Inactive"
                      : "Active"), 1)
                      ], 2)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_47, [
                  _hoisted_48,
                  _createVNode("div", _hoisted_49, _toDisplayString(_ctx.formatDate(_ctx.detailData.created_at)), 1),
                  _createVNode("div", _hoisted_50, _toDisplayString(_ctx.detailData.created_by), 1)
                ]),
                _createVNode("div", _hoisted_51, [
                  _hoisted_52,
                  _createVNode("div", _hoisted_53, _toDisplayString(_ctx.formatDate(_ctx.detailData.updated_at || _ctx.detailData.created_at)), 1),
                  _createVNode("div", _hoisted_54, _toDisplayString(_ctx.detailData.updated_by || _ctx.detailData.created_by), 1)
                ]),
                (_ctx.isEditAble)
                  ? (_openBlock(), _createBlock("div", _hoisted_55, [
                      _withDirectives(_createVNode(_component_button_fill, {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (
              _ctx.detailData.status.toLowerCase() === 'active'
                ? _ctx.onStop()
                : _ctx.goEdit(_ctx.id)
            )),
                        title: 
              _ctx.detailData.status.toLowerCase() === 'active'
                ? 'Hentikan Embargo'
                : 'Edit'
            ,
                        class: "px-8 bg-red-lp-300 mr-2"
                      }, null, 8, ["title"]), [
                        [_vShow, _ctx.detailData.status.toLowerCase() !== 'expired']
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
      ]))
}